<template>
  <div class="top_navabr">
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <button class="navbar-toggler" id="toggleButton" onclick="window.global.toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="top-nav-content">
          <a href="javascript:void(0)" class="notification" :class="{ 'zero': notificationCount <= 0 }"
            :data-after="notificationCount" @click="showNotifications"><i class="fa-solid fa-bell icons"></i></a>
          <a class="btn" @click="createProject" :class="{ disabled: activeUser.status !== 2 }">Postar um projeto</a>
        </div>
        <div id="navbarNav" style="display: none">
          <ul class="navbar-nav nav-2">
            <li>
              <a class="nav-link" :class="{ active: this.section === 'DashboardPage' }" href="/"><i
                  class="fa-solid fa-house icons"></i>Dashboard</a>
            </li>
            <li>
              <a class="nav-link" href="/perfil" :class="{ active: this.section === 'ProfilePage' }"><i
                  class="fa-solid fa-user icons" style="padding-left: 3px; margin-right: 11px"></i>Perfil</a>
            </li>
            <li>
              <a class="nav-link" href="/projetos"
                :class="{ active: this.section === 'ProjectListPage' || this.section === 'ProjectPage' }"><i
                  class="fa-solid fa-briefcase icons" style="padding-left: 2px; margin-right: 11px"></i>Meus projetos</a>
            </li>
            <li>
              <a class="nav-link" href="/encontre-talentos" :class="{
                active:
                  this.section === 'AssistantListPage' ||
                  this.section === 'AssistantPage' ||
                  this.section === 'ProposalPage'
              }"><i class="fa-solid fa-magnifying-glass icons"
                  style="padding-left: 2px; margin-right: 11px"></i>Encontre
                talentos
              </a>
            </li>
            <li>
              <a class="nav-link" :href="logoutURL"><i class="fa-solid fa-arrow-right-from-bracket" style="padding-left: 2px; margin-right: 7px"></i>
              Sair
              </a>
            </li>
            <!-- <li>
              <a
                class="nav-link"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#support"
                ><i class="fa-solid fa-headset icons"></i>Support</a
              >
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Config from "../../../resources/config.js";
import ClientManager from "../../js/services/client.js";

export default {
  data() {
    return {};
  },

  computed: {
    section() {
      return this.$store.state.activeSection;
    },
    activeUser() {
      return this.$store.state.activeUser;
    },
    notificationCount() {
      return this.activeUser.last_notif_id - this.activeUser.seen_notif_id;
    },
    logoutURL() {
      return `${Config.apiHost}/logout`;
    },
  },

  methods: {
    createProject() {
      if (this.activeUser.status === 1) {
        this.showError(
          "Seu perfil ainda está sendo analisado.\n\nAssim que for aprovado pela nossa equipe, você poderá postar projetos."
        );
        return;
      }
      this.showCreateProject(ClientManager, null);
    },

    async showNotifications() {
      let ctx = this;
      let $modal = $("#notificationsModal");
      $modal.find('.notification').html('<div class="loading">Carregando...</div>');
      $modal.modal('show');

      $modal.off().on('shown.bs.modal', async function () {
        try {
          let notifications = await ClientManager.getNotifications(ctx.activeUser.last_notif_id);

          if (notifications.length > 0) {
            $modal.find('.notification').html('');
            notifications.forEach(notification => {
              let n = $(
                '<div class="item">' +
                '   <div class="sourch">' +
                '       <img src="/assets/img/notification_mail.png" alt="" />' +
                '       <div class="text">' +
                '           <p></p>' +
                '           <span class="date"></span>' +
                '       </div>' +
                '   </div>' +
                '</div>');


              if (notification.notification_type === 'signup-approved') {
                n.find('.text > p').html('Bem-vindo à Virtap! <a href="javascript:void(0)" class="link">Poste seu primeiro projeto</a>.');
                n.find('a').on('click', function () {
                  $modal.modal('hide');
                  ctx.createProject();
                });
              } else if (notification.notification_type === 'profile-approved') {
                n.find('.text > p').html('Seu cadastro foi aprovado! <a href="javascript:void(0)" class="link">Poste seu primeiro projeto</a>.');
                n.find('a').on('click', function () {
                  $modal.modal('hide');
                  ctx.createProject();
                });
              } else if (notification.notification_type === 'project-approved') {
                let data = JSON.parse(notification.notification_data);
                n.find('.text > p').html('Seu projeto <strong data-project-title></strong> foi aprovado.');
                n.find('a').on('click', function () {
                  $modal.modal('hide');
                  ctx.createProject();
                });
                n.find('[data-project-title]').text(data.project_title);
              } else if (notification.notification_type === 'proposal-received') {
                let data = JSON.parse(notification.notification_data);
                n.find('.text > p').html('Você recebeu uma proposta de <strong data-assistant-name></strong> para o seu projeto <strong data-project-title></strong>. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-la</a>.');
                n.find('a').attr('href', '/proposta/' + data.project_id + '/' + data.assistant_id);
                n.find('[data-assistant-name]').text(data.assistant_name);
                n.find('[data-project-title]').text(data.project_title);
              } else if (notification.notification_type === 'project-expiring') {
                let data = JSON.parse(notification.notification_data);
                n.find('.text > p').html('Seu projeto <strong data-project-title></strong> será automaticamente encerrado em breve. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-lo</a>.');
                n.find('a').attr('href', '/projeto/' + data.project_id);
                n.find('[data-project-title]').text(data.project_title);
              } else if (notification.notification_type === 'project-closed') {
                let data = JSON.parse(notification.notification_data);
                n.find('.text > p').html('Seu projeto <strong data-project-title></strong> foi encerrado. <a href="javascript:void(0)" target="_blank" class="link">Clique aqui para visualizá-lo</a>.');
                n.find('a').attr('href', '/projeto/' + data.project_id);
                n.find('[data-project-title]').text(data.project_title);
              }

              n.find('.date').text(ctx.formatElapsedTime(notification.registration_timestamp));
              if (notification.user_notification_id > ctx.activeUser.seen_notif_id) {
                n.addClass('active');
              }

              $modal.find('.notification').append(n);
            });

          } else {
            $modal.find('.notification').html('<div class="loading">Nenhuma notificação disponível.</div>');
          }

          try {
            await ClientManager.setLastSeenNotifications(ctx.activeUser.last_notif_id);
          } catch (err) {
            console.log(err);
          }
          ctx.activeUser.seen_notif_id = ctx.activeUser.last_notif_id;
        } catch (err) {
          console.log(err);
          $modal.find('.notification').html('<div class="loading text-danger">Erro ao carregar as notificações.<br/>Por favor, tente novamente.<br/>Se o problema persistir, atualize a página.</div>');
        }


      });

    }
  },
};
</script>
